import { createSelector } from '@ngrx/store';

import { PolicyClient } from '@models/swagger';
import { State } from './reducer';
import { selectPoliciesState } from '../selectors';

export const getData = createSelector(selectPoliciesState, (state: State) => state.data);

export const getError = createSelector(selectPoliciesState, (state: State) => state.error);

export const getLoading = createSelector(selectPoliciesState, (state: State) => state.loading);

export const mapData = <T>(fn: (data: PolicyClient[]) => T) =>
  createSelector(selectPoliciesState, (state: State) => fn(state.data));
